module.exports = __webpack_public_path__ + "static/media/next-icon-spoon-o.a6508684.svg";